/** @jsx jsx */

import { css, jsx } from '@emotion/core';

const AddRemmoveBtn = ({
  color = '#000',
  left = 0,
  top = 0,
  size = 24,
  rotation = 0,
  style = {},
  onClick,
}: {
  color?: string;
  left?: number;
  top?: number;
  size?: number;
  rotation?: number;
  style?: object;
  onClick?: (e?: any) => void;
}) => (
  <div
    css={css`
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    `}
    style={{
      ...style,
      position: 'relative',
      left,
      top,
      width: size,
      height: size,
      transform: `rotate(${rotation}deg)`,
      transformOrigin: '50% 50%',
    }}
    onClick={onClick}
  >
    <svg width={`${size}px`} height={`${size}px`} viewBox="0 0 24 24">
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Second"
          transform="translate(-308.000000, -366.000000)"
          stroke={color}
        >
          <g id="Delete" transform="translate(309.000000, 367.000000)">
            <path
              d="M11,4.88888889 L11,17.1111111"
              id="Line-Copy-4"
              strokeLinecap="square"
              transform="translate(11.000000, 11.000000) rotate(-45.000000) translate(-11.000000, -11.000000) "
            />
            <path
              d="M17.1111111,11 L4.88888889,11"
              id="Line-Copy-5"
              strokeLinecap="square"
              transform="translate(11.000000, 11.000000) rotate(-45.000000) translate(-11.000000, -11.000000) "
            />
          </g>
        </g>
      </g>
    </svg>
  </div>
);

export default AddRemmoveBtn;
